import { Typography, Stack } from '@mui/material';
import { ReportTierOptions } from '@StandingAccess/types';

import { aponoColors } from '@utils/colors';

interface AssessmentTierWidgetLabelProps {
  type: ReportTierOptions;
}

export function AssessmentTierWidgetIcon({ type }: AssessmentTierWidgetLabelProps) {
  const typeMap: Record<ReportTierOptions, string> = {
    Critical: aponoColors.error[700],
    High: aponoColors.error[500],
    Medium: aponoColors.tertiary[500],
    Low: aponoColors.success[500],
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" stroke={typeMap[type]} strokeWidth="4" />
    </svg>
  );
}

export function AssessmentTierWidgetLabel({ type }: AssessmentTierWidgetLabelProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <AssessmentTierWidgetIcon type={type} />
      <Typography variant="body2">{type}</Typography>
    </Stack>
  );
}
